export enum StatusEnum {
  PartiallyIssued = 'Partially Issued',
  Completed = 'Completed',
  Open = 'Open',

}
